import { defineNuxtPlugin, useCookie } from '#app'
import { type DependencyContainer } from 'tsyringe'
import { DITokens } from '@/di'

/**
 * dataLayerの初期化処理。ログイン中の場合はuser_idを設定
 */
export default defineNuxtPlugin(async app => {
  window.dataLayer = window.dataLayer || []

  // 旧ECサイトのuser_idがある場合は設定
  const legacyEcUserId = useCookie('legacy_ec_user_id')
  if (legacyEcUserId.value) {
    window.dataLayer.push({ legacy_ec_user_id: legacyEcUserId.value })
  }

  const container = app.$container as DependencyContainer
  if (container && container.isRegistered(DITokens.ProfileStore)) {
    try {
      const { profile } = container.resolve(DITokens.ProfileStore)
      if (profile) {
        window.dataLayer.push({ user_id: profile.data.uid })
      }
    } catch (e) {
      // Do nothing
    }
  }
})
